import * as yup from "yup";
import enUs from "../../../lang/en-us";
import {
  getAddressType,
  getIncomeValue,
  getOccupation,
  getPepValue,
  getSourceOfWealth,
} from "../portfolios/utils";

export type kycValuesType = {
  occupation: string;
  pepFlag: string;
  annualIncomeSlab: string;
  fatherName: string;
  spouseName: string;
  netWorth: string;
  sourceOfWealth: string;
  placeOfBirth: string;
  addressType: string;
  netWorthDate: string | Date;
};

const {
  dashboard: {
    FatcaDeclaration: { kycFields },
  },
} = enUs;

export const kycValidationSchema = (isIndianResident: string) =>
  yup.object({
    occupation: yup.string().required(kycFields.form.errors.occupation),
    pepFlag: yup.string().required(kycFields.form.errors.pepFlag),
    annualIncomeSlab: yup
      .string()
      .required(kycFields.form.errors.annualIncomeSlab),
    fatherName: yup
      .string()
      .min(KYC_MIN_LENGHTHS.fatherName, kycFields.form.errors.minLength),
    spouseName: yup
      .string()
      .min(KYC_MIN_LENGHTHS.spouseName, kycFields.form.errors.minLength),
    addressType: yup.string().required(kycFields.form.errors.addressType),
    sourceOfWealth: yup.string().required(kycFields.form.errors.sourceOfWealth),
    placeOfBirth: yup
      .string()
      .required(kycFields.form.errors.placeOfBirth)
      .min(KYC_MIN_LENGHTHS.placeOfBirth, kycFields.form.errors.pobMinLength),
    netWorthDate: yup.string().required(kycFields.form.errors.netWorthDate),
    netWorth: yup
      .string()
      .required(kycFields.form.errors.netWorth)
      .test(
        "greaterThanZero",
        kycFields.form.errors.zeroError,
        (value: any) => Number(value) > 0
      ),
  });
const getKeyByValue = (object: { [key: string]: string }, value: string) => {
  const key = Object.keys(object).find(
    (key) => object[key].toLowerCase() === value.toLowerCase()
  );
  return key !== undefined ? key : value;
};
export const prepareKycValidations = (payload: kycValuesType) => {
  if (payload.addressType?.length > 2) {
    payload.addressType = getKeyByValue(getAddressType, payload.addressType);
  }
  if (payload.pepFlag?.length > 1) {
    payload.pepFlag = getKeyByValue(getPepValue, payload.pepFlag);
  }
  if (payload.annualIncomeSlab?.length > 2) {
    payload.annualIncomeSlab = getKeyByValue(
      getIncomeValue,
      payload.annualIncomeSlab
    );
  }
  if (payload.sourceOfWealth?.length > 2) {
    payload.sourceOfWealth = getKeyByValue(
      getSourceOfWealth,
      payload.sourceOfWealth
    );
  }
  if (payload.occupation?.length > 2) {
    payload.occupation = getKeyByValue(getOccupation, payload.occupation);
  }
  return payload;
};
export const MAX_LENGTHS = {
  fatherName: 70,
  spouseName: 100,
  placeOfBirth: 100,
  otherIdentity: 50,
  netWorth: 18,
  remarks: 100,
};
export const KYC_MIN_LENGHTHS = {
  fatherName: 2,
  spouseName: 2,
  placeOfBirth: 2,
};
